<template>
  <transition name="fade" v-bind="$attrs">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: "FadeTransition",
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity $short;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
